import { useTranslations } from '@qonsoll/translation'

export default useTranslations
